(function () {
  'use strict';

  const STORAGE_KEY = 'storeAnalysisSkailamaPreview';

  const OFFER_LABELS = {
    FBT: 'FBT',
    PB: 'Product Bundle',
  };

  // ---- DOM refs -----------------------------------------------------------
  const root = document.querySelector('[data-store-analysis]');
  if (!root) return;

  const form = root.querySelector('[data-shop-search-form]');
  const input = root.querySelector('[data-shop-search-input]');
  const grid = root.querySelector('[data-offers-grid]');
  const statusEl = root.querySelector('[data-offers-status]');
  const loaderEl = root.querySelector('[data-offers-loader]');
  const configUrl = root.dataset.offersConfigUrl;

  function setLoading(loading) {
    if (!loaderEl) return;
    if (loading) loaderEl.removeAttribute('hidden');
    else loaderEl.setAttribute('hidden', '');
  }

  // ---- Helpers ------------------------------------------------------------
  // Accepts:
  //   "allbirds"                    → allbirds.myshopify.com
  //   "allbirds.myshopify.com"      → allbirds.myshopify.com
  //   "https://allbirds.com/stuff"  → allbirds.com
  //   "my-store.com"                → my-store.com
  // Rejects: empty, spaces-only, invalid characters
  function normalizeShopDomain(raw) {
    if (!raw) return null;
    let s = String(raw).trim().toLowerCase();
    // Strip protocol and trailing path/query
    s = s.replace(/^https?:\/\//, '').replace(/[/?#].*$/, '');
    if (!s) return null;

    // Only allow valid domain characters: letters, digits, hyphens, dots
    if (/[^a-z0-9.\-]/.test(s)) return null;

    // If no dot, treat as myshopify store name
    if (s.indexOf('.') === -1) {
      s = s + '.myshopify.com';
    }

    // Must have at least one dot and no leading/trailing dots or hyphens
    if (s.startsWith('.') || s.endsWith('.') || s.startsWith('-') || s.endsWith('-')) return null;

    return s;
  }

  function setStatus(msg, tone) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.dataset.tone = tone || '';
  }

  function pickRandomN(arr, n) {
    const copy = arr.slice();
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy.slice(0, Math.min(n, copy.length));
  }

  // ========================================================================
  // STEP 1 — Fake API call (replace with real backend later)
  // Fetches products from the domain and returns shaped offer data.
  // ========================================================================
  async function getOfferDetails(domain) {
    const url = 'https://' + domain + '/products.json?limit=50';
    let res;
    try {
      res = await fetch(url, { credentials: 'omit' });
    } catch (e) {
      throw new Error('Could not reach ' + domain + '. Please check the domain and try again.');
    }

    if (res.status === 404 || res.status === 401 || res.status === 403) {
      throw new Error(domain + ' does not appear to be a valid Shopify store.');
    }
    if (!res.ok) {
      throw new Error(domain + ' responded with an error (HTTP ' + res.status + ').');
    }

    let json;
    try {
      json = await res.json();
    } catch (e) {
      throw new Error(domain + ' did not return valid product data. It may not be a Shopify store.');
    }

    if (!json.products || !Array.isArray(json.products)) {
      throw new Error(domain + ' does not appear to be a valid Shopify store.');
    }

    const products = json.products;
    debugger;
    console.log(products);
    if (!products.length) return { data: [] };

    // Pick 4 random products for each offer (handle, title, image, price, vendor)
    const shape = (p) => {
      const variant = p.variants && p.variants[0];
      const image = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || null;
      return {
        handle: p.handle,
        title: p.title,
        image: image,
        price: variant ? variant.price : null,
        vendor: p.vendor || null,
      };
    };
    const pickedPB = pickRandomN(products, 4).map(shape);
    const pickedFBT = pickRandomN(products, 4).map(shape);

    const frequentBoughtData = (gfb.settings.frequentBoughtData ?? []).filter(offer => offer.isActive);
    let data = [
      {
        offerId:"FBT-958462",
        offerType: "PB",
        industry: "HOME DECOR",
        subIndustry: "HOME & LIFESTYLE", 
      },
      {
        offerId: "FBT-107578",
        offerType: "PB",
        industry: "FASHION & APPAREL",
        subIndustry: "JEWELRY",
      },
      {
        offerId:"FBT-672486",
        offerType: "PB",
        industry: "BEAUTY & SKINCARE",
        subIndustry: "BEAUTY & COSMETICS",
      },
      {
        offerId:"FBT-246623",
        offerType: "PB",
        industry: "BEAUTY & SKINCARE",
        subIndustry: "BEAUTY & COSMETICS",
      },
      {
        offerId:"FBT-367985",
        offerType: "FBT",
        industry: "HOME & LIFESTYLE",
        subIndustry: "HOME DECOR",
      },
      {
        offerId:"FBT-534220",
        offerType: "FBT",
        industry: "ELECTRONICS & TECH",
        subIndustry: "PHONE ACCESSORIES",
      },
      {
        offerId:"FBT-281278",
        offerType: "FBT",
        industry: "BEAUTY & SKINCARE",
        subIndustry: "BEAUTY & COSMETICS",
      },
      {
        offerId:"FBT-025682",
        offerType: "FBT",
        industry: "FOOTWEAR",
        subIndustry: "ACTIVEWEAR & ATHLEISURE",
      }
    ];

    data = pickRandomN(data , 4);
    data = data.map((d) => {
      const offerId = d.offerId;
      const offerProductsCount = frequentBoughtData.find(offer => offer.offerId === offerId)?.selectedProducts?.length ?? 4;
      const offerProducts = pickRandomN(products , offerProductsCount).map(shape);
      const firstProductHandle = offerProducts[0].handle;
      const currentProductDetails = products.find(product => product.handle === firstProductHandle) ?? products[0];
      const title = currentProductDetails?.title ?? "Product Title";
      const images = (currentProductDetails?.images ?? []).map(imageConfig => imageConfig.src ?? "").filter(curr => curr);

      return { ...d , offerProducts , parentProductDetails: { images , title }}
    });

    return {
      data
    };
  }

  // ========================================================================
  // STEP 2 — Load static offers config
  // Fetches offers-config.json from Shopify CDN.
  // ========================================================================
  async function loadOffersConfig() {
    if (!configUrl) {
      console.warn('[store-analysis] No offers-config URL found.');
      return [];
    }
    const res = await fetch(configUrl, { credentials: 'omit' });
    if (!res.ok) throw new Error('Failed to load offers-config: HTTP ' + res.status);
    return res.json();
  }

  // ========================================================================
  // STEP 3 — Map offers to product handles
  // Matches each API offer to a config entry by offerType+industry+subIndustry.
  // Falls back to industry "DEFAULT" if no exact match.
  // Returns: { [productHandle]: offerData }
  // ========================================================================
  function mapOffersToHandles(apiOffers, offersConfig) {
    const result = {};

    apiOffers.forEach((offer) => {
      // Exact match
      let match = offersConfig.find((cfg) =>
        cfg.offerType === offer.offerType &&
        cfg.industry === offer.industry &&
        cfg.subIndustry === offer.subIndustry
      );

      // Fallback to DEFAULT industry
      if (!match) {
        match = offersConfig.find((cfg) =>
          cfg.offerType === offer.offerType &&
          cfg.industry === 'DEFAULT' &&
          cfg.subIndustry === offer.subIndustry
        );
      }

      if (match) {
        const offerWithHandle = {
          offerId: offer.offerId,
          offerProducts: offer.offerProducts,
          offerType: offer.offerType,
          industry: offer.industry,
          subIndustry: offer.subIndustry,
          parentProductDetails: offer.parentProductDetails,
          productHandle: match.productHandle,
        };
        result[match.productHandle] = offerWithHandle;
      }
    });

    return result;
  }

  // ========================================================================
  // STEP 4 — Render cards + click handler
  // ========================================================================
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatPrice(value) {
    if (value == null || value === '') return '';
    const n = typeof value === 'number' ? value : parseFloat(value);
    if (!isFinite(n)) return '';
    // Shopify products.json returns prices as strings in store currency units.
    return '$' + n.toFixed(2);
  }

  function buildThumbsHTML(products) {
    const slots = 4;
    let html = '';
    for (let i = 0; i < slots; i++) {
      const p = products[i];
      if (p && p.image) {
        const url = p.image.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_240x$1$2');
        html +=
          '<div class="store-analysis__thumb">' +
            '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy" />' +
          '</div>';
      } else {
        html += '<div class="store-analysis__thumb store-analysis__thumb--placeholder">·</div>';
      }
    }
    return html;
  }

  function buildProductRowsHTML(products) {
    return products.map((p) => {
      const title = typeof p === 'string' ? p : (p.title || '');
      const price = typeof p === 'string' ? '' : formatPrice(p.price);
      return (
        '<div class="store-analysis__product">' +
          '<span class="store-analysis__product-title">' + escapeHtml(title) + '</span>' +
          (price ? '<span class="store-analysis__product-price">' + escapeHtml(price) + '</span>' : '') +
        '</div>'
      );
    }).join('');
  }

  function renderCards(offersMap, sourceShop) {
    grid.innerHTML = '';

    Object.keys(offersMap).forEach((productHandle, index) => {
      const offer = offersMap[productHandle];
      const label = OFFER_LABELS[offer.offerType] || offer.offerType;
      const productCount = (offer.offerProducts || []).length;

      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'store-analysis__card';
      card.style.animationDelay = (index * 60) + 'ms';

      card.innerHTML =
        '<div class="store-analysis__card-head">' +
          '<span class="store-analysis__card-badge" data-bundle-type="' + escapeHtml(offer.offerType) + '">' + escapeHtml(label) + '</span>' +
          '<span class="store-analysis__card-industry" data-industry="' + escapeHtml(offer.industry) + '">' + escapeHtml(offer.industry) + '</span>' +
        '</div>' +
        '<div class="store-analysis__card-thumbs">' + buildThumbsHTML(offer.offerProducts || []) + '</div>' +
        '<div class="store-analysis__card-body">' + buildProductRowsHTML(offer.offerProducts || []) + '</div>' +
        '<div class="store-analysis__card-foot">' +
          '<span class="store-analysis__card-count">' + productCount + ' product' + (productCount === 1 ? '' : 's') + '</span>' +
          '<span class="store-analysis__card-cta">Preview offer →</span>' +
        '</div>';

      card.addEventListener('click', () => {
        const payload = {
          sourceShop: sourceShop,
          offerId: offer.offerId,
          productHandle: productHandle,
          offerProducts: offer.offerProducts,
          offerType: offer.offerType,
          industry: offer.industry,
          subIndustry: offer.subIndustry,
          parentProductDetails: offer.parentProductDetails,
          createdAt: Date.now(),
        };

        const targetUrl = '/products/' + productHandle + '?preview_mode=true&variant_design=auto';
        const newTab = window.open(targetUrl, '_blank');

        if (newTab) {
          // Set on the new tab's window object and sessionStorage once it loads
          newTab.addEventListener('DOMContentLoaded', () => {
            newTab.storeAnalysisSkailamaPreview = payload;
            try {
              newTab.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
            } catch (e) {
              // sessionStorage can fail in private mode
            }
          });

          // Also set immediately on window in case DOMContentLoaded already fired
          newTab.storeAnalysisSkailamaPreview = payload;
        }
      });

      grid.appendChild(card);
    });
  }

  // ---- Main flow ----------------------------------------------------------
  async function runAnalysis(rawInput) {
    const domain = normalizeShopDomain(rawInput);
    if (!domain) {
      setStatus('Enter a valid store domain to analyze.', 'error');
      return;
    }

    setStatus('', '');
    grid.innerHTML = '';
    setLoading(true);

    try {
      // Step 1: Get offer details (fake API)
      const apiResponse = await getOfferDetails(domain);
      if (!apiResponse.data.length) {
        setStatus('No products found for ' + domain + '.', 'warn');
        setLoading(false);
        return;
      }

      // Step 2: Load static offers config
      const offersConfig = await loadOffersConfig();

      // Step 3: Map offers to handles
      const offersMap = mapOffersToHandles(apiResponse.data, offersConfig);

      if (!Object.keys(offersMap).length) {
        setStatus('No matching offers found for ' + domain + '.', 'warn');
        setLoading(false);
        return;
      }

      // Step 4: Render cards
      renderCards(offersMap, domain);
      setLoading(false);
      setStatus('Showing ' + Object.keys(offersMap).length + ' offer(s) for ' + domain + '.', 'ok');

    } catch (err) {
      console.error('[store-analysis]', err);
      setStatus(err.message || ('Couldn\'t analyze ' + domain + '.'), 'error');
      setLoading(false);
    }
  }

  // ---- Wire up events -----------------------------------------------------
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const value = input ? input.value : '';
      const normalized = normalizeShopDomain(value);
      if (normalized) {
        const url = new URL(window.location.href);
        url.searchParams.set('shop', normalized);
        history.replaceState({}, '', url);
      }
      runAnalysis(value);
    });
  }

  // Restore from ?shop= on page load
  const shopParam = new URLSearchParams(window.location.search).get('shop');
  if (shopParam) {
    if (input) input.value = shopParam;
    runAnalysis(shopParam);
  }
})();
